import { render, staticRenderFns } from "./newformTemp.vue?vue&type=template&id=b15a2a80&scoped=true&"
import script from "./newformTemp.vue?vue&type=script&lang=js&"
export * from "./newformTemp.vue?vue&type=script&lang=js&"
import style0 from "@/assets/css/NewStyleSheet.css?vue&type=style&index=0&id=b15a2a80&scoped=true&lang=css&"
import style1 from "./newformTemp.vue?vue&type=style&index=1&lang=css&"
import style2 from "./newformTemp.vue?vue&type=style&index=2&id=b15a2a80&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b15a2a80",
  null
  
)

/* custom blocks */
import block0 from "./newformTemp.vue?vue&type=custom&index=0&blockType=link&href=https%3A%2F%2Ffonts.googleapis.com%2Fcss%3Ffamily%3DSource%2BSans%2BPro%26display%3Dswap&rel=stylesheet"
if (typeof block0 === 'function') block0(component)

export default component.exports